import React from 'react'
import useStyles from './editDetailsStyles'
import CountryList from './CountryList'
import { PlacesNameAutocompleteFormsy } from 'app/components/PlacesAutocompleteFormsy'
import { TextInput } from 'app/components/FormsyHelperComponent'
import StatesSwitchList from './StatesSwitchList'

const AddressFields = ({
  formFields,
  setFormFields,
  setCity,
  countryData,
  placesNameAutocompleteFormsyData,
  address2,
  physicalCityName,
  physicalPostalCode,
  statesSwitchList,
  updateCustomAddressFieldData,
  addressData,
  parentMethod,
  isLocal,
}) => {
  const {
    countryDataLabel,
    countryDataName,
    countryDataValue,
    propOfCountryCode,
    propOfRegionType,
    propOfCountryId,
  } = countryData
  const {
    labelId: placesNameLabelId,
    placeholderId: placesNamePlaceholderId,
    cityProperty: placeNameCityProperty,
    variant: placeNameVariant,
    name: placeName,
    value: placeNameValue,
    restriction: placeNameRestriction,
  } = placesNameAutocompleteFormsyData
  const styleClass = useStyles()
  const {
    labelId: address2labelId,
    placeholderId: address2PlaceHolderId,
    variant: address2Variant,
    name: address2Name,
    value: address2Value,
  } = address2

  const {
    labelId: physicalCityNameLabelId,
    placeholderId: physicalCityNamePlaceHolderId,
    name: physicalCityFieldName,
    value: physicalCityNameValue,
  } = physicalCityName

  const {
    labelId: physicalPostalCodeLabelId,
    placeholderId: physicalPostalCodeplaceHolderId,
    name: physicalPostalCodeName,
    value: physicalPostalCodeValue,
  } = physicalPostalCode

  const {
    value: statesSwitchListValue,
    regionType: statesSwitchListRegionType,
    countryId: statesSwitchListCountryId,
    name: statesSwitchListname,
  } = statesSwitchList

  return (
    <>
      <div className={styleClass.formRow}>
        <div className={styleClass.formRowIcon} />
        <div className={styleClass.formRowInputs}>
          <div className={styleClass.formRowItemTwo}>
            <CountryList
              label={countryDataLabel}
              name={countryDataName}
              value={countryDataValue}
              formFields={formFields}
              setFormFields={setFormFields}
              propOfCountryCode={propOfCountryCode}
              propOfRegionType={propOfRegionType}
              propOfCountryId={propOfCountryId}
            />
          </div>
        </div>
      </div>

      <div className={styleClass.formRow}>
        <div className={styleClass.formRowIcon} />
        <div className={styleClass.formRowInputs}>
          <div className={styleClass.formRowItemTwo}>
            <PlacesNameAutocompleteFormsy
              labelId={placesNameLabelId}
              placeholderId={placesNamePlaceholderId}
              variant={placeNameVariant}
              onSelectPlaceSuggestion={({ suggestion }) => {
                setCity(placeNameCityProperty, suggestion, {
                  method: parentMethod,
                  addressData: addressData,
                  isLocal: isLocal,
                })
                updateCustomAddressFieldData &&
                  updateCustomAddressFieldData({
                    currentValue: suggestion.description,
                    addressDataId:
                      addressData && (addressData.localId || addressData.id),
                    labelName: 'Street Address',
                    labelMethod: parentMethod,
                    isLocal: isLocal,
                    countryCode:
                      addressData.customAttributes.physicalCountryCode,
                    countryId: undefined,
                    regionType: undefined,
                  })
              }}
              isShowMaxLength={false}
              name={placeName}
              value={placeNameValue}
              restriction={placeNameRestriction}
            />
          </div>
        </div>
      </div>

      <div className={styleClass.formRow}>
        <div className={styleClass.formRowIcon} />
        <div className={styleClass.formRowInputs}>
          <div className={styleClass.formRowItemTwo}>
            <TextInput
              margin="dense"
              containerClassName="MuiFormControl-fullWidth"
              labelId={address2labelId}
              placeholderId={address2PlaceHolderId}
              variant={address2Variant}
              fullWidth
              name={address2Name}
              value={address2Value}
              onChange={(event) =>
                updateCustomAddressFieldData &&
                updateCustomAddressFieldData({
                  currentValue: event.target.value,
                  addressDataId:
                    addressData && (addressData.localId || addressData.id),
                  labelName: 'Street Address Line 2',
                  labelMethod: parentMethod,
                  isLocal: isLocal,
                  countryCode: undefined,
                  countryId: undefined,
                  regionType: undefined,
                })
              }
            />
          </div>
        </div>
      </div>

      <div className={styleClass.formRow}>
        <div className={styleClass.formRowIcon} />
        <div className={styleClass.formRowInputs}>
          <div className={styleClass.formRowItemTwo}>
            <TextInput
              margin="dense"
              containerClassName="MuiFormControl-fullWidth"
              labelId={physicalCityNameLabelId}
              placeholderId={physicalCityNamePlaceHolderId}
              variant="standard"
              fullWidth
              name={physicalCityFieldName}
              value={physicalCityNameValue}
              onChange={(event) => {
                updateCustomAddressFieldData &&
                  updateCustomAddressFieldData({
                    currentValue: event.target.value,
                    addressDataId:
                      addressData && (addressData.localId || addressData.id),
                    labelName: 'City',
                    labelMethod: parentMethod,
                    isLocal: isLocal,
                    countryCode: undefined,
                    countryId: undefined,
                    regionType: undefined,
                  })
              }}
            />
          </div>
        </div>
      </div>

      <StatesSwitchList
        value={statesSwitchListValue}
        regionType={statesSwitchListRegionType}
        countryId={statesSwitchListCountryId}
        styleClass={styleClass}
        name={statesSwitchListname}
        updateCustomAddressFieldData={updateCustomAddressFieldData}
        parentId={addressData && (addressData.localId || addressData.id)}
        parentMethod={parentMethod}
        isLocal={isLocal}
      />
      <div className={styleClass.formRow}>
        <div className={styleClass.formRowIcon} />
        <div className={styleClass.formRowInputs}>
          <div className={styleClass.formRowItemTwo}>
            <TextInput
              margin="dense"
              containerClassName="MuiFormControl-fullWidth"
              labelId={physicalPostalCodeLabelId}
              placeholderId={physicalPostalCodeplaceHolderId}
              variant="standard"
              fullWidth
              name={physicalPostalCodeName}
              value={physicalPostalCodeValue}
              onChange={(event) =>
                updateCustomAddressFieldData &&
                updateCustomAddressFieldData({
                  currentValue: event.target.value,
                  addressDataId:
                    addressData && (addressData.localId || addressData.id),
                  labelName: 'Postal Code',
                  labelMethod: parentMethod,
                  isLocal: isLocal,
                  countryCode: undefined,
                  countryId: undefined,
                  regionType: undefined,
                })
              }
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default AddressFields
